const getProgressColor = (tenantData: any, isDarkMode: boolean) => {
  const generalTheme = tenantData?.settings?.["general-theme"];
  const advancedTheme = tenantData?.settings?.["general-theme"];

  const masterColor = isDarkMode
    ? generalTheme.themeDarkModeMasterColor
    : generalTheme.themeMasterColor;

  return advancedTheme?.themeCourseProgressStyle === "automatic"
    ? masterColor
    : {
        "0%": advancedTheme?.themeCourseProgressColor1,
        "100%": advancedTheme?.themeCourseProgressColor2,
      };
};

export default getProgressColor;
